/* import __COLOCATED_TEMPLATE__ from './more-actions-menu.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: '',
  // Passed in
  dropdownClass: null,
  iconTitle: null,
  iconTitleId: null,
  popoverId: null
});